import React from 'react'
import { connect } from 'react-redux'
import ServerDownModal from 'components/modals/common/ServerDownModal'
import NoNetworkModal from 'components/modals/common/NoNetworkModal'
import ChatHelpModal from 'components/modals/common/ChatHelpModal'
import {
  MODAL_NETWORK_OFF,
  MODAL_SERVER_DOWN,
  MODAL_BOARDING_ERROR_HIBOUTIK,
  hideModal
} from 'redux/modules/modals'

const mapActionCreators = {
  hideModal
}
const mapStateToProps = state => {
  return {
    currentModal: state.modals.currentModal,
    payload: state.modals.payload,
    auth: state.auth
  }
}
const CommonModalConductor = props => {
  if (props.auth.authenticated === null || !props.auth.authenticated) {
    return null
  }
  switch (props.currentModal) {
    case MODAL_NETWORK_OFF:
      return <NoNetworkModal />
    case MODAL_SERVER_DOWN:
      return <ServerDownModal />
    case MODAL_BOARDING_ERROR_HIBOUTIK:
      return <ChatHelpModal errorMessage={props.payload} />
    default:
      return null
  }
}

export default connect(mapStateToProps, mapActionCreators)(CommonModalConductor)



// WEBPACK FOOTER //
// ./src/containers/CommonModalConductor.js